import { network, constants } from 'lib_ui-services';
import logging from '@sstdev/lib_logging';

export default {
    verb: 'doingClearCache',
    namespace: 'application',
    relation: 'runtime',
    description: 'Clear the cache and redirect to the login page',
    //this is the actual logic:
    logic
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @template T
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 */

async function logic({ dispatch }) {
    try {
        const ok = await asyncConfirmationModal(dispatch);
        if (!ok) return;

        const message = 'Clearing cache...';
        dispatch(
            {
                message,
                timeout: 5000,
                addToList: false,
                isError: false, //todo: gl2025 remove
                variant: 'warning',
                type: constants.notificationTypes.TOAST
            },
            {
                verb: 'pop',
                namespace: 'application',
                relation: 'notification'
            }
        );

        // Clear the cache by removing all service worker registrations, indexedDB databases, and clearing local storage
        await network.clearCache();
    } catch (error) {
        logging.error(error);
        const message =
            'An error occurred while attempting to reset the application.  You may need to refresh the web browser page and try again.';
        dispatch(
            {
                message,
                timeout: 5000,
                addToList: false,
                isError: true, //todo: gl2025 remove
                variant: 'error',
                type: constants.notificationTypes.TOAST
            },
            {
                verb: 'pop',
                namespace: 'application',
                relation: 'notification'
            }
        );
    }
}

async function asyncConfirmationModal(dispatch) {
    return new Promise(resolve => {
        const message =
            'This action will delete any pending requests and will require a user to be online to log in again.  Continue?';
        dispatch(
            {
                message,
                okButtonText: 'YES',
                icon: 'warning',
                iconColorStyle: constants.COLOR_STYLES.Warning,
                variant: constants.VARIANT.Error,
                okAction: () => resolve(true),
                cancelAction: () => resolve(false)
            },
            { verb: 'confirm', namespace: 'application', relation: 'user' }
        );
    });
}
